import { excludeByIndex } from '~/utils/arrayUtils/excludeByIndex';

export const replaceByIndex = <T>(arr: T[], index: number, replacement: T): T[] => {
  const [before, after] = excludeByIndex(index, arr);

  return [...before, ...([replacement] as T[]), ...after];
};
